import React from 'react'
import RedButton, { Props as RedButtonProps } from '../../../react4xp/components/RedButton'

function RedButtonMacro(props: RedButtonProps) {
  return (
    <RedButton {...props} />
  )
}

export default (props: RedButtonProps) => <RedButtonMacro {...props} />
